import S from 's-js';
import TZDate from 'lib/TZDate';
import { TZUtils } from 'lib/tzutils';
import { TopicCard } from 'data/models/TopicCard';

export interface TopicCardListItemParams {
    draft : TopicCard;
    canConfirm : () => boolean;
    clock : { now : () => TZDate }; // clock to use for last update time ago text
}

export function TopicCardListItem(
    tzutils : TZUtils,
    { draft, canConfirm, clock } : TopicCardListItemParams
) {
    const comments = draft.Comments.sort((c1, c2) =>
            // Sort by event date descending, w/ unknown events at the end
            c1.Event() ?
                c2.Event() ?
                    +c2.Event()!.Date() - +c1.Event()!.Date() :
                    1 :
                c2.Event() ?
                    -1 :
                    0),
        mostRecentComment = S(() => comments().length > 0 ? comments()[0] : null),
        lastUpdated = S(() => mostRecentComment() && mostRecentComment()!.Event() && mostRecentComment()!.Event()!.Date() > draft.LastAnswer() ?
            mostRecentComment()!.Event()!.Date() : draft.LastAnswer());

    return {
        Model: draft,
        LastUpdated: lastUpdated,
        Now: () => clock.now(),
        CanConfirm: canConfirm,
        Confirm, Deny, WithdrawConfirmation, WithdrawDenial
    };

    function Confirm() {
        draft.ConfirmedDate(tzutils.now());
    }

    function Deny() {
        draft.DeniedDate(tzutils.now());
    }

    function WithdrawConfirmation() {
        draft.ConfirmedDate(null);
    }

    function WithdrawDenial() {
        S.freeze(() => {
            draft.DeniedDate(null);
            draft.ConfirmedDate(null);
        });
    }
}
export type TopicCardListItem = ReturnType<typeof TopicCardListItem>;


// WEBPACK FOOTER //
// ./apps/portcall/topiccardlistitem/model.ts